import { render, staticRenderFns } from "./TitanVerticalTable.vue?vue&type=template&id=72f5b0fc"
import script from "./TitanVerticalTable.vue?vue&type=script&lang=js"
export * from "./TitanVerticalTable.vue?vue&type=script&lang=js"
import style0 from "./TitanVerticalTable.vue?vue&type=style&index=0&id=72f5b0fc&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f5b0fc')) {
      api.createRecord('72f5b0fc', component.options)
    } else {
      api.reload('72f5b0fc', component.options)
    }
    module.hot.accept("./TitanVerticalTable.vue?vue&type=template&id=72f5b0fc", function () {
      api.rerender('72f5b0fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/TitanVerticalTable.vue"
export default component.exports